import React from "react";
import { Box, Badge, Button, Flex, Text, Skeleton, useColorModeValue } from "@chakra-ui/react";
import { Archive, Ellipsis, Eye, ShieldAlert } from "lucide-react";
import ThreeDotMenu from "components/Menus/ThreeDotMenu";
import StatusBadge, {
    getCategoryVariant,
} from "components/Badges/StatusBadge";

const categoryColorScheme = {
  "Getting Started": "green",
  "Account Issues": "blue",
  "Payments": "purple",
  "Driver Support": "yellow",
  "Driver Partner": "cyan",
  "Technical Support": "teal",
  "General": "pink",
  "Other": "gray",
};

const HelpTopicCard = ({ title, category, created_at, image, onEdit, onArchive, loading }) => {
  const cardBg = useColorModeValue("gray.100", "gray.700");
  const badgeColor = categoryColorScheme[category] || "gray";
  const textColor = useColorModeValue("gray.500", "white");

  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const imageUrl = image 
  ? `${BASE_URL.replace(/\/$/, '')}/${image.replace(/^\/?/, '')}` 
  : null;

  const menuItems = [
    {
      icon: <Eye size={16} />,
      text: 'View Topic',
      onClick: onEdit,
    },
    {
      icon: <Archive size={16} />,
      text: 'Archive Topic',
      onClick: onArchive,
      extraIcon: <ShieldAlert size={16} color="pink" />,
    },
  ];

  return (
    <Box
      borderWidth="1px"
      borderRadius="lg"
      overflow="hidden"
      p="6"
      boxShadow="md"
      maxW="sm"
      bg={cardBg}
    >
      <Flex justifyContent="space-between" alignItems="center" mb={2}>
        {loading ? (
          <Skeleton height="20px" width="80px" />
        ) : (
          <StatusBadge
    label={category}
    variant={getCategoryVariant(category)}
/>
        )}
        {loading ? (
          <Skeleton height="20px" width="20px" borderRadius="50%" />
        ) : (
          <ThreeDotMenu
            icon={<Ellipsis size={20} color="grey" />}
            items={menuItems}
          />
        )}
      </Flex>

      <Flex justifyContent="center" mb={4}>
        {loading ? (
          <Skeleton height="150px" width="100%" />
        ) : imageUrl ? (
          <img
            src={imageUrl}
            alt={title}
            style={{ borderRadius: "8px", width: "100%", maxHeight: "150px" }}
          />
        ) : (
          <Skeleton height="150px" width="100%" />
        )}
      </Flex>

      {loading ? (
        <Skeleton height="20px" width="200px" />
      ) : (
        <Text fontWeight="bold" fontSize="lg" mb={2} textAlign="start" noOfLines={1}>
          {title}
        </Text>
      )}

      <Flex mt={4} justifyContent="space-between" alignItems="center">
        <Flex alignItems="center">
          {loading ? (
            <>
              <Skeleton height="15px" width="50px" mr={2} />
              <Skeleton height="15px" width="70px" />
            </>
          ) : (
            <>
              <Text fontSize="xs" fontWeight="bold" color={textColor} mr={2}>
                Created At
              </Text>
              <Text fontSize="xs" color={textColor}>
                {created_at ? new Date(created_at).toLocaleDateString() : "N/A"}
              </Text>
            </>
          )}
        </Flex>

        {loading ? (
          <Skeleton height="20px" width="100px" />
        ) : (
          <Button
            onClick={onEdit}
            color="#071D54"
            bg="gray.100"
            variant="link"
            fontSize="xs"
          >
            View Topic {">"}
          </Button>
        )}
      </Flex>
    </Box>
  );
};

export default HelpTopicCard;
